import { TFunction } from 'i18next';
import _ from 'lodash';
import {
  AssignmentMetric,
  AssignmentMetricDescriptorBase,
} from './assignmentMetric.types';

export const getAssignmentMetricDescriptors = (
  t: TFunction<'app'>,
): AssignmentMetricDescriptorBase[] => [
  {
    type: 'stockUom',
    path: 'stockUom',
    rangeType: 'distinct',
    aggregationFn: 'max',
    nullValueBucketTitle: t('Empty', { ns: 'app' }),
  },
  {
    type: 'stockUomQuantity',
    path: 'stockUomQuantity',
    rangeType: 'range-linear',
    aggregationFn: 'sum',
    sequentialPaletteId: 'heatmap-analytics',
    nullValueBucketTitle: t('Unknown', { ns: 'app' }),
  },
  // Actuality Occupancy Metrics
  // {
  //   type: 'actuality-occupancy-rate',
  //   path: 'locationStockOccupancyRate',
  //   rangeType: 'range-linear',
  //   aggregationFn: 'max',
  //   sequentialPaletteId: 'heatmap-analytics',
  //   nullValueBucketTitle: t`Empty`,
  // },
  // {
  //   type: 'actuality-occupancy-volume',
  //   path: 'locationStockVolume',
  //   rangeType: 'range-linear',
  //   aggregationFn: 'sum',
  //   sequentialPaletteId: 'heatmap-analytics',
  //   nullValueBucketTitle: t`Empty`,
  // },
  // {
  //   type: 'actuality-utilization-rate',
  //   path: 'locationUtilizationRate',
  //   rangeType: 'range-linear',
  //   aggregationFn: 'max',
  //   sequentialPaletteId: 'heatmap-analytics',
  //   nullValueBucketTitle: t`Empty`,
  // },
  // {
  //   type: 'actuality-utilization-max-uom-rate',
  //   path: 'locationMaxUomUtilizationRate',
  //   rangeType: 'range-linear',
  //   aggregationFn: 'max',
  //   sequentialPaletteId: 'heatmap-analytics',
  //   nullValueBucketTitle: t`Empty`,
  // },
];

export const getAssignmentMetricDescriptorsMap = (t: TFunction<'app'>) =>
  _.keyBy(getAssignmentMetricDescriptors(t), d => d.type) as Record<
    AssignmentMetric,
    AssignmentMetricDescriptorBase
  >;
